import { render, staticRenderFns } from "./ProductInfoField.vue?vue&type=template&id=18a15aa0&scoped=true&"
import script from "./ProductInfoField.vue?vue&type=script&lang=js&"
export * from "./ProductInfoField.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoField.vue?vue&type=style&index=0&id=18a15aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a15aa0",
  null
  
)

export default component.exports